<template>
    <div :class="classes">
        <div class="floating-actions__button">
            <CompassIconButton type="primary" icon="check" @click.stop="save" />
        </div>
        <div class="floating-actions__button">
            <CompassIconButton icon="close" @click.stop="cancel" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        float: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        classes() {
            return {
                'floating-actions': true,
                'floating-actions--is-floating': this.float,
            };
        },
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$emit('save');
        },
    },
};
</script>
<style lang="scss" scoped>
.floating-actions {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
    justify-content: flex-end;

    &__button {
        background-color: var(--colors-common-background-default);
        border-radius: var(--spacing-0);
    }

    &--is-floating {
        position: absolute;
        right: 0;
        top: calc(100% + 4px);
        z-index: 1;

        &::v-deep {
            .compass-icon-button {
                box-shadow: var(--box-shadows-medium);
                flex-shrink: 0;
            }
        }
    }
}
</style>
